import { memo } from "react";

import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";

// -----------------------------------------------------------------------------

const AWSConnectSetupPageError = memo(function AWSConnectSetupPageError({
  show,
  onTryAgain,
  children,
}: AWSConnectSetupPageErrorProps) {
  return show ? (
    <Alert severity="error">
      {children ?? "There was an error"}
      <Button
        variant="contained"
        color="error"
        sx={{ mt: 2 }}
        onClick={onTryAgain as React.MouseEventHandler<HTMLButtonElement>}
      >
        Try Again
      </Button>
    </Alert>
  ) : null;
});

export default AWSConnectSetupPageError;

// -----------------------------------------------------------------------------

interface AWSConnectSetupPageErrorProps {
  show: boolean;
  onTryAgain: Function;
  children: React.ReactNode;
}
